import SolarPanelSvg from 'assets/solar-energy-icons/solar-panel.svg'
import BadgeCheckSvg from 'assets/solar-energy-icons/badge-check.svg'
import BuildingCircleCheckSvg from 'assets/solar-energy-icons/building-circle-check.svg'
import ListCheckSvg from 'assets/solar-energy-icons/list-check.svg'
import ShieldExclamationSvg from 'assets/solar-energy-icons/shield-exclamation.svg'
import SunHazeSvg from 'assets/solar-energy-icons/sun-haze.svg'

export const solarEnergy = [
  {
    icon: SolarPanelSvg,
    title: 'Como funciona a instalação do painel solar?',
    content:
      'Após a visita técnica, será elaborado o projeto do sistema de energia solar. Uma equipe profissional fará a instalação e a conexão será homologada junto à distribuidora de energia.',
    bulletItems: []
  },
  {
    icon: ListCheckSvg,
    title: 'O Checklist para quem planeja investir em painéis solares',
    content:
      'Ao pesquisar empresas de energia solar no Brasil, o consumidor deve estar atento aos seguintes pontos:',
    bulletItems: [
      'Custo da compra e da instalação',
      'Qualidade dos equipamentos',
      'Garantias e manutenção',
      'Reputação da empresa'
    ]
  },
  {
    icon: BuildingCircleCheckSvg,
    title: 'O que procurar em uma empresa de Energia Solar',
    content:
      'A melhor empresa de energia solar deve garantir um atendimento ágil, entender a necessidade do cliente e ter capacidade de responder às principais dúvidas. Além disso, é importante verificar a reputação da empresa, incluindo histórico de projetos já realizados e as garantias oferecidas ao projeto.',
    bulletItems: []
  },
  {
    icon: ShieldExclamationSvg,
    title: 'Garantias das empresas de energia solar',
    content:
      'O Portal Solar oferece 1 ano de garantia para instalação do sistema de energia solar. Além disso, também existe a garantia fornecida pelas empresas de energia solar responsáveis pela fabricação dos equipamentos, como painéis solares e inversores.',
    bulletItems: []
  },
  {
    icon: SunHazeSvg,
    title: 'Razões para contratar uma empresa de energia solar',
    content:
      'As empresas de energia solar sérias e de qualidade atestada garantem que o projeto de energia solar seja instalado de forma segura e eficiente, atendendo de forma adequada a demanda de consumo e economia do cliente.',
    bulletItems: []
  },
  {
    icon: BadgeCheckSvg,
    title: 'Conclusão',
    content:
      'Um sistema fotovoltaico mal dimensionado ou instalado errado pode não atender às expectativas do cliente e ainda gerar riscos. É essencial contar com engenharia qualificada, equipamentos de qualidade e garantia.',
    bulletItems: []
  }
]
